export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    bgVariant: {
      type: String,
      default: null
    },
    borderVariant: {
      type: String,
      default: null
    },
    textVariant: {
      type: String,
      default: null
    },
    operation: {
      type: Boolean,
      default: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components-base/mixins/card-mixin.js